export const operatorCategories = {
  ARITHMETIC: { id: "arithmetic", label: "Arithmetic" },
  AGGREGATION: { id: "aggregation", label: "Aggregations" },
  CONDITIONAL: { id: "conditional", label: "Conditional" },
  COMPARISON: { id: "comparison", label: "Comparison" },
  LOGICAL: { id: "logical", label: "Logical" },
};

export const aggregationOperators = [
  "sum",
  "count",
  "count_distinct",
  "min",
  "max",
  "avg",
  "median",
];

export const conditionalKeywords = ["IF", "THEN", "ELSE", "END"];

export const comparisonOperators = ["=", "!=", ">", "<", ">=", "<="];

export const logicalOperators = ["AND", "OR", "NOT", "IN", "ISNULL"];

export const formulaConfigKeys = {
  CALCULATED_FIELDS: "CALCULATED_FIELDS",
  CALCULATED_FIELDS_NO_AGGREGATION: "CALCULATED_FIELDS_NO_AGGREGATION",
  COLUMN_HEADER: "COLUMN_HEADER",
  ENTITY_PROPERTY_DETAILS: "ENTITY_PROPERTY_DETAILS",
};

export const componentOperatorConfig = {
  [formulaConfigKeys.CALCULATED_FIELDS]: [
    operatorCategories.AGGREGATION.id,
    operatorCategories.CONDITIONAL.id,
    operatorCategories.COMPARISON.id,
    operatorCategories.LOGICAL.id,
    operatorCategories.ARITHMETIC.id,
  ],
  [formulaConfigKeys.CALCULATED_FIELDS_NO_AGGREGATION]: [
    operatorCategories.CONDITIONAL.id,
    operatorCategories.COMPARISON.id,
    operatorCategories.LOGICAL.id,
    operatorCategories.ARITHMETIC.id,
  ],
  [formulaConfigKeys.COLUMN_HEADER]: [operatorCategories.ARITHMETIC.id],
  [formulaConfigKeys.ENTITY_PROPERTY_DETAILS]: [operatorCategories.ARITHMETIC.id],
};

export const operatorsByCategory = {
  [operatorCategories.ARITHMETIC.id]: [
    { value: "+", label: "Add (+)" },
    { value: "-", label: "Subtract (-)" },
    { value: "*", label: "Multiply (*)" },
    { value: "/", label: "Divide (/)" },
  ],
  [operatorCategories.AGGREGATION.id]: [
    { value: "sum", label: "SUM ()" },
    { value: "count", label: "COUNT ()" },
    { value: "count_distinct", label: "COUNTD ()" },
    { value: "min", label: "MIN ()" },
    { value: "max", label: "MAX ()" },
    { value: "avg", label: "AVG ()" },
    { value: "median", label: "MEDIAN ()" },
  ],
  [operatorCategories.CONDITIONAL.id]: [
    { value: "IF", label: "IF" },
    { value: "THEN", label: "THEN" },
    { value: "ELSE", label: "ELSE" },
    { value: "END", label: "END" },
  ],
  [operatorCategories.COMPARISON.id]: [
    { value: "=", label: "Equals (=)" },
    { value: "!=", label: "Not Equals (!=)" },
    { value: ">", label: "Greater Than (>)" },
    { value: "<", label: "Less Than (<)" },
    { value: ">=", label: "Greater or Equal (>=)" },
    { value: "<=", label: "Less or Equal (<=)" },
  ],
  [operatorCategories.LOGICAL.id]: [
    { value: "AND", label: "AND" },
    { value: "OR", label: "OR" },
    { value: "NOT", label: "NOT" },
    { value: "IN", label: "IN ()" },
    { value: "ISNULL", label: "ISNULL ()" },
  ],
};

export const getOperatorsForComponent = (componentKey) => {
  try {
    const categoryIds = componentOperatorConfig[componentKey] || [];

    return categoryIds
      .map((categoryId) => {
        const category = Object.values(operatorCategories).find(
          (c) => c.id === categoryId,
        );
        return {
          category: category,
          operators: operatorsByCategory[categoryId] || [],
        };
      })
      .filter((group) => group.operators.length > 0);
  } catch (error) {
    console.error(
      "An error occurred while getting operators for component: ",
      error,
    );
  }
};
